<template>
  <el-footer class="footer">
    <p style="margin: 0; opacity: 0.6">2026 杭州麦田熊科技有限公司</p>
  </el-footer>
</template>

<script>
export default {
  name: "FooterComp",
};
</script>

<style scoped>
.footer {
  background: #2e3b4e;
  color: #fff;
  padding: 40px 0;
  margin-top: 50px;
  text-align: center;
}
</style>
